import { Component, OnInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from '../../services/common/title.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'logout',
    template: require('./../../templates/account/logoutView.component.html'),
    providers: [TranslationService, TitleService ]
})
export class LogoutViewComponent implements OnInit {
    redirectUrl: string;
    autoRedirect: string;
    errorMessage: string;
    isSuccess: boolean;
    confirmed = false;

    //Translations
    formSuccess: string;
    logoutFormSuccess: string;
    logoutFormPageTitle: string;
    logoutFormRedirectClick: string;
    logoutFormRedirectLink: string;
    logoutFormRedirectEnd: string;

    constructor(private route: ActivatedRoute, private translationService: TranslationService, private titleService: TitleService) {
        this.redirectUrl = this.route.snapshot.queryParams.redirectUrl;
        this.autoRedirect = this.route.snapshot.queryParams.autoRedirect;
    }

    ngOnInit() {
        if (this.autoRedirect === "1") {
            window.location.href = this.redirectUrl;
        }
        this.titleService.setTitle(this.route.snapshot.data['title']);
        this.initTranslations();
    }

    initTranslations() {
        this.translationService.translate('form.success', 'Success!', (data) => this.formSuccess = data);
        this.translationService.translate('logoutform.success', 'Logout was successful.', (data) => this.logoutFormSuccess = data);
        this.translationService.translate('logoutform.pageTitle', 'Logout Page', (data) => this.logoutFormPageTitle = data);
        this.translationService.translate('logoutform.redirectPart1', 'Click', (data) => this.logoutFormRedirectClick = data);
        this.translationService.translate('logoutform.redirectPart2', 'here', (data) => this.logoutFormRedirectLink = data);
        this.translationService.translate('logoutform.redirectPart3', 'to return to application.', (data) => this.logoutFormRedirectEnd = data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/logoutView.component.ts